import React, { useState, useEffect } from 'react';
import {
  Row, Col, Spin, notification,
} from 'antd';
import {
  useNavigate, useLocation,
} from 'react-router-dom';
import CondutividadeDetails from '../condutividadeEletrica/details/Details';
import SateliteDetails from '../satelite/details/Details';
import VantDetails from '../vant/details/Details';
import CondutividadeSummary from '../condutividadeEletrica/summary/Summary';
import SateliteSummary from '../satelite/summary/Summary';
import VantSummary from '../vant/summary/Summary';
import SuccessSolicitation from '../../../serviceComponents/successSolicitation/SuccessSolicitation';
import { getUserType } from '../../../../../utils/users';

const Flow = () => {
  const initialParameters = () => ({
    isSkippingSteps: false,
    serviceList: [],

    selectedService: {
      id: 0,
      idCode: '',
      name: '',
      description: '',
      types: [],
    },

    selectedType: {
      id: 0,
      idCode: '',
      name: '',
      subtypes: [],
    },

    selectedProperty: {
      id: '',
      name: '',

      location: {
        lat: null,
        lon: null,
      },

      registeredOn: '',
      matriculation: '',
    },

    selectedMatriculation: getUserType() === 'COOPERCITRUS' ? null : 'COOPERATIVE',

    selectedOwner: {
      id: '',
      name: '',
    },

    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    talhoesSelecionados: [],
  });

  const [currentPage, setCurrentPage] = useState(-1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const locationObject = useLocation();
  const [serviceRequestParameters, setServiceRequestParameters] = useState(initialParameters());

  const removeSelectedField = (id) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        talhoesSelecionados: previous.talhoesSelecionados.filter((v) => v.id !== id),
      });
    });
  };

  useEffect(() => {
    if (!locationObject.state?.serviceRequestParams) {
      notification.error({
        description: 'Houve um erro ao solicitar o serviço.',
      });
      navigate('/service/new');
      return;
    }
    setServiceRequestParameters(locationObject.state?.serviceRequestParams);
    setCurrentPage(0);
  }, []);

  const previousPage = (parameters) => {
    if (currentPage === 0) {
      navigate('/service/new', {
        state: {
          skipToPage: 3,
          serviceID: serviceRequestParameters.selectedService.id,
          matriculation: serviceRequestParameters.matriculation,
          allServiceParameters: serviceRequestParameters,
        },
      });
      return;
    }

    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous - 1);
  };

  const nextPage = (parameters) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous + 1);
  };

  return (
    <div className="Flow">
      <Spin tip="Carregando..." spinning={loading}>
        <Row>
          <Col span={24}>
            <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
              {
                currentPage === 0
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA'
                && (
                  <CondutividadeDetails
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
              {
                currentPage === 0
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-SATELITE'
                && (
                  <SateliteDetails
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
              {
                currentPage === 0
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-VANT'
                && (
                  <VantDetails
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 1 ? 'block' : 'none' }}>
              {
                currentPage === 1
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA'
                && (
                  <CondutividadeSummary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
              {
                currentPage === 1
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-SATELITE'
                && (
                  <SateliteSummary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
              {
                currentPage === 1
                && serviceRequestParameters.selectedSubType.idCode === 'GEOFERT-ZONA_MANEJO-VANT'
                && (
                  <VantSummary
                    previousPage={previousPage}
                    nextPage={nextPage}
                    serviceRequestParameters={serviceRequestParameters}
                    removeSelectedField={removeSelectedField}
                  />
                )
              }
            </div>

            <div style={{ display: currentPage === 2 ? 'block' : 'none' }}>
              <SuccessSolicitation
                previousPage={previousPage}
                params={serviceRequestParameters}
              />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

Flow.propTypes = {};
Flow.defaultProps = {};

export default Flow;
